import { useState } from "react"
import { CgEnter } from "react-icons/cg"
import { FaPlusCircle } from "react-icons/fa"

function App() {
  const [code, setCode] = useState("")

  return (
    <div className="bg-slate-900 w-full h-fit min-h-screen flex flex-col items-center justify-center">
      <div className="max-w-xs w-full flex flex-col gap-6 my-6">
        <h1 className="text-white text-3xl font-semibold">KFKounter</h1>
        <a
          href="/create"
          className="bg-green-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
        >
          <FaPlusCircle className="mr-2 h-5 w-5" /> Skapa ny
        </a>
        <div className="w-full border border-t border-x-0 border-y-0" />
        <input
          placeholder="kod"
          className="rounded-lg h-16 text-center text-3xl"
          maxLength={7}
          minLength={7}
          onChange={(e) => setCode(e.target.value)}
        />
        <a
          href={`/${code.toLowerCase()}`}
          className="bg-blue-500 text-white w-full rounded-lg h-16 flex justify-center items-center"
        >
          <CgEnter className="mr-2 h-5 w-5" /> Gå med
        </a>
      </div>
    </div>
  )
}

export default App
